import { isServer } from '@tanstack/react-query';

/**
 * Awaits a metadata query only for bots, so SEO tags are in the initial HTML `<head>`.
 * Regular users get non-blocking streaming and metadata is hoisted client-side by React 19.
 *
 * The `<Seo />` component must be in its own `<Suspense>` boundary, isolated from other
 * components that may suspend (Hero, Campaigns, etc.) — otherwise their suspension
 * bubbles up and prevents the meta tags from rendering.
 *
 * Use this in route loaders for the query that feeds `<Seo />`:
 *
 * ```ts
 * await ensureSeoData(context,
 *   context.queryClient.ensureQueryData(portalMetadataOptions({ ... })),
 * );
 * ```
 *
 * Same pattern as Next.js `htmlLimitedBots` — bots get blocking metadata, users get streaming.
 * Docs: https://nextjs.org/docs/app/api-reference/config/next-config-js/htmlLimitedBots
 * Regex: https://github.com/vercel/next.js/blob/canary/packages/next/src/shared/lib/router/utils/html-bots.ts
 */
export async function ensureSeoData(context: { isBot: boolean }, promise: Promise<unknown>): Promise<void> {
	if (isServer && context.isBot) {
		await promise;
	}
}
